/* v=1781620844.1619883 */
/* Regroupe le filtre Date de parution (S&D `filter.p.m.global.dateSortie`)
   en décennies "1900 à 1909", "1910 à 1919", etc. Tri DESC (plus récent en
   premier). Filtre les valeurs aberrantes (< 1600 ou > année courante).
   Cliquer une décennie sélectionne toutes les années du bucket et soumet
   le form S&D. */
(function () {
  if (!/^\/(collections|search)/.test(location.pathname)) return;

  var MIN_YEAR = 1600;
  var MAX_YEAR = new Date().getFullYear();
  var FILTER_NAME = 'filter.p.m.global.dateSortie';

  function findOriginalDetails() {
    var input = document.querySelector('#FacetFiltersForm input[name="' + FILTER_NAME + '"]');
    return input ? input.closest('details') : null;
  }

  function decadeKey(year) {
    var floor = Math.floor(year / 10) * 10;
    return floor + ' à ' + (floor + 9);
  }

  function collectBuckets(originalDetails) {
    var inputs = originalDetails.querySelectorAll('input[type="checkbox"][name="' + FILTER_NAME + '"]');
    var buckets = new Map();
    inputs.forEach(function (inp) {
      var y = parseInt(inp.value, 10);
      if (!y || isNaN(y) || y < MIN_YEAR || y > MAX_YEAR) return;
      var key = decadeKey(y);
      var b = buckets.get(key) || { years: [], count: 0, checked: false, decadeStart: Math.floor(y / 10) * 10 };
      b.years.push(inp.value);
      var li = inp.closest('li, label');
      if (li) {
        // Le label contient "2019 (5)" puis (visually-hidden) "2019 (5 produits)".
        // On prend le premier "(N)" pour récupérer le compte.
        var m = li.textContent.match(/\((\d+)\)/);
        if (m) b.count += parseInt(m[1], 10);
      }
      if (inp.checked) b.checked = true;
      buckets.set(key, b);
    });
    return buckets;
  }

  function build(originalDetails, buckets) {
    if (document.getElementById('Details-date-decade')) return;

    var d = document.createElement('details');
    d.id = 'Details-date-decade';
    d.className = 'facets__disclosure-vertical js-filter';
    d.setAttribute('data-index', '85');
    d.setAttribute('data-bh-flab', 'date de parution');
    var anyChecked = false;
    buckets.forEach(function (b) { if (b.checked) anyChecked = true; });
    if (anyChecked) d.open = true;

    var s = document.createElement('summary');
    s.className = 'facets__summary caption-large focus-offset';
    s.innerHTML = '<div><span>Date de parution</span></div>'
      + '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
    d.appendChild(s);

    var wrap = document.createElement('div');
    wrap.className = 'facets__display-vertical';
    wrap.style.cssText = 'max-height:380px;overflow-y:auto;';
    var ul = document.createElement('ul');
    ul.className = 'facets__list list-unstyled no-js-hidden';
    ul.style.padding = '0 0 1rem';

    // Tri DESC : plus récent en premier
    var sorted = [...buckets.entries()].sort(function (a, b) {
      return b[1].decadeStart - a[1].decadeStart;
    });

    sorted.forEach(function (entry) {
      var key = entry[0], b = entry[1];
      if (b.count === 0 && !b.checked) return;
      var li = document.createElement('li');
      li.className = 'list-menu__item facets__item';
      var lbl = document.createElement('label');
      lbl.className = 'facet-checkbox';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.checked = b.checked;
      cb.addEventListener('change', function () { apply(key, b.years, cb.checked, originalDetails); });
      lbl.appendChild(cb);
      // Dawn rend la case via 2 SVG (rectangle + checkmark) stylés par .facet-checkbox dans component-facets.css
      var boxSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      boxSvg.setAttribute('width', '1.6rem'); boxSvg.setAttribute('height', '1.6rem');
      boxSvg.setAttribute('viewBox', '0 0 16 16'); boxSvg.setAttribute('aria-hidden', 'true'); boxSvg.setAttribute('focusable', 'false');
      boxSvg.innerHTML = '<rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>';
      lbl.appendChild(boxSvg);
      var checkSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      checkSvg.setAttribute('aria-hidden', 'true'); checkSvg.setAttribute('class', 'icon icon-checkmark');
      checkSvg.setAttribute('width', '1.1rem'); checkSvg.setAttribute('height', '0.7rem');
      checkSvg.setAttribute('viewBox', '0 0 11 7'); checkSvg.setAttribute('fill', 'none');
      checkSvg.innerHTML = '<path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>';
      lbl.appendChild(checkSvg);
      var txt = document.createElement('span');
      txt.setAttribute('aria-hidden', 'true');
      txt.textContent = key + ' (' + b.count + ')';
      lbl.appendChild(txt);
      li.appendChild(lbl);
      ul.appendChild(li);
    });

    wrap.appendChild(ul);
    d.appendChild(wrap);
    originalDetails.parentNode.insertBefore(d, originalDetails);
    originalDetails.style.display = 'none';
  }

  function apply(decadeKey, years, check, originalDetails) {
    var inputs = originalDetails.querySelectorAll('input[type="checkbox"][name="' + FILTER_NAME + '"]');
    var set = new Set(years);
    inputs.forEach(function (inp) {
      if (set.has(inp.value)) inp.checked = check;
    });
    // Navigation directe via URL (évite tout conflit avec le facet-filters-form de Dawn
    // qui pourrait intercepter le submit et perdre une partie des paramètres).
    var url = new URL(location.href);
    var params = url.searchParams;
    params.delete(FILTER_NAME);
    inputs.forEach(function (inp) {
      if (inp.checked) params.append(FILTER_NAME, inp.value);
    });
    params.delete('page');
    location.href = url.toString();
  }

  function rewrite() {
    var od = findOriginalDetails();
    if (!od) return;
    var buckets = collectBuckets(od);
    if (!buckets.size) return;
    build(od, buckets);
  }

  function start() {
    rewrite();
    new MutationObserver(function () {
      if (document.getElementById('Details-date-decade')) return;
      if (findOriginalDetails()) rewrite();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
